
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="isShowing"
    width="60%"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    class="fixHeight"
  >
    <el-form
      ref="carrierService"
      v-loading="isSaving"
    >
      <el-row>
        <el-col
          :span="4"
        >
          `<el-menu
            :default-active="step.toString()"
            @select="handleOpen"
          >
            <el-menu-item index="1">
              <i class="el-icon-menu" />
              <span slot="title">
                Details
              </span>
            </el-menu-item>
            <el-menu-item index="2">
              <i class="el-icon-document" />
              <span slot="title">
                Limits
              </span>
            </el-menu-item>
            <el-menu-item index="3">
              <i class="el-icon-setting" />
              <span slot="title">
                Constraints
              </span>
            </el-menu-item>
            <el-menu-item index="4">
              <i class="el-icon-setting" />
              <span slot="title">
                Items
              </span>
            </el-menu-item>
          </el-menu>`
        </el-col>
        <el-col
          :span="18"
          :gutter="15"
          style="margin-left: 20px;"
        >
          <DetailForm
            v-if="step === 1"
            ref="detailForm"
            :detail="service"
          />
          <div v-if="step === 2">
            <Item
              ref="itemForm"
              :item="service"
            />
            <Weight
              ref="weightForm"
              :item="service"
            />
            <Volume
              ref="volume"
              :item="service"
            />
          </div>
          <div v-if="step === 3">
            <Warning
              ref="warn"
              :item="service"
            />
            <Constraints
              ref="constraints"
              :item="service"
            />
          </div>
          <ConfigItem
            v-if="step === 4"
            ref="conf"
            :item="service"
          />
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="isShowing = false">
        Cancel
      </el-button>
      <el-button
        type="default"
        :loading="isSaving"
        :disabled="step === 1"
        @click.native="step--"
      >
        Previous
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="nextStep"
      >
        Next {{ step }}/4
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import DetailForm from '@/components/Application/Manage/Carriers/Service/Detail'
import Item from '@/components/Application/Manage/Carriers/Service/Items'
import Weight from '@/components/Application/Manage/Carriers/Service/Weight'
import Volume from '@/components/Application/Manage/Carriers/Service/Volume'
import Warning from '@/components/Application/Manage/Carriers/Service/Warnings'
import Constraints from '@/components/Application/Manage/Carriers/Service/Constraints'
import ConfigItem from '@/components/Application/Manage/Carriers/Service/ConfigItem'
export default {
  components: {
    DetailForm,
    Item,
    Weight,
    Volume,
    Warning,
    Constraints,
    ConfigItem
  },
  props: {
    service: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      isShowing: false,
      isSaving: false,
      step: 1,
      isFullscreen: false
    }
  },
  methods: {
    handleOpen (key) {
      this.step = parseInt(key)
    },
    getTitle () {
      if (!this.service.id) {
        return 'Create Carrier Service'
      } else {
        return 'Edit Carrier Service'
      }
    },
    nextStep () {
      switch (this.step) {
        case 1:
          this.$refs.detailForm.$refs.form.validate((valid) => {
            if (valid) {
              this.step = 2
            }
          })
          break
        case 2:
          this.$refs.itemForm.$refs.form.validate((valid) => {
            if (valid) {
              this.step = 3
            }
          })
          break
        case 3:
          this.$refs.constraints.$refs.form.validate((valid) => {
            if (valid) {
              this.step = 4
            }
          })
          break
        case 4:
          this.$refs.conf.$refs.form.validate((valid) => {
            if (valid) {
              this.isSaving = true
              this.create()
            }
          })
          break
        case 5:
          this.$refs.warn.$refs.form.validate((valid) => {
            if (valid) {
              this.isSaving = true
              this.create()
            }
          })
          break
        case 6:
          this.$refs.constraints.$refs.form.validate((valid) => {
            if (valid) {
              this.step = 7
            }
          })
          break
        case 7:
          this.$refs.conf.$refs.form.validate((valid) => {
            if (valid) {
              this.isSaving = true
              this.create()
            }
          })
          break
      }
    },
    showDialog () {
      this.isShowing = true
      this.step = 1
    },
    closeDialog () {
      this.isShowing = false
      this.step = 1
    },
    create () {
      if (this.service.create === true) {
        this.$sdk.carrier_service.create(this.service, builder => {
          builder.context = { resource: 'carrier', id: this.$route.params.carrierId }
        }).then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
          .finally(() => {
            this.closeDialog()
            this.isSaving = false
            this.$emit('refresh')
          })
      } else {
        this.service.update(builder => {
          builder.context = { resource: 'carrier', id: this.$route.params.carrierId }
        }).then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
          .finally(() => {
            this.closeDialog()
            this.isSaving = false
            this.$emit('refresh')
          })
      }
      this.step = 1
    }
  }

}
</script>

<style>

</style>
